import { message, Popover, Space, Table, Tag } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
} from '@ant-design/icons';
import {baseUrl} from "../../../../src/config"
export const ProductsEnquiries=()=>{
     
    const [enquiries,setEnquiries]=useState([])
   
    
const { Column, ColumnGroup } = Table;

interface DataType {
  key: React.Key;
  firstName: string;
  lastName: string;
  age: number;
  address: string;
  tags: string[];
}
const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
const navigate=useNavigate()
// const data: DataType[] = [
//   {
//     key: '1',
//     firstName: 'John',
//     lastName: 'Brown',
//     age: 32,
//     address: 'New York No. 1 Lake Park',
//     tags: ['nice', 'developer'],
//   },
//   {
//     key: '2',
//     firstName: 'Jim',
//     lastName: 'Green',
//     age: 42,
//     address: 'London No. 1 Lake Park',
//     tags: ['loser'],
//   },
//   {
//     key: '3',
//     firstName: 'Joe',
//     lastName: 'Black',
//     age: 32,
//     address: 'Sydney No. 1 Lake Park',
//     tags: ['cool', 'teacher'],
//   },
// ];
    useEffect(()=>{
   
   getEnquiries()
    },[])
    const getEnquiries = async () => {
        try {
          const resp = await axios.get(
            `${baseUrl}account/${loginData.id}/orders`,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          console.log(resp.data); // Log the response to check
        
          setEnquiries(resp?.data);
        } catch (e) {
            if(e.response.status==401){
                navigate("/admin/login")
            }
          console.error(e);
        }
      }
      const deleteEnquiries = async (id) => {
        try {
          const resp = await axios.delete(
            `${baseUrl}account/${loginData.id}/orders/${id}`,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            message.success("Product enquiry deleted successfully")
            getEnquiries()
          }
        
        } catch (e) {
          console.error(e);
          message.error("Failed to delete enquiry")
          if(e.response.status==401){
            navigate("/admin/login")
        }
        }
      }
    return(
        <div>
             <Table<DataType> dataSource={enquiries}  pagination={{ pageSize: 20 }}>
      <Column title="Name" dataIndex="name" key="name" />
      <Column title="Mobile Number" dataIndex="mobile" key="mobile" />
    <Column title="Email" dataIndex="email" key="email" />
    <Column title="Product Name" dataIndex="productName" key="productName" />
    <Column title="Quantity" dataIndex="quantity" key="quantity" />
    <Column
      title="Notes"
      dataIndex="notes"
      key="notes"
      render={(notes: string) => (
        <>
       <Popover content={<div>{notes}</div>} trigger="click" ><div style={{color:"green",cursor:"pointer"}}>View notes</div></Popover>
        </>
      )}
    />
    <Column
      title="Action"
      key="action"
      render={(_: any, record: any) => (
         <Space size="middle">
             <DeleteOutlined color="#FFF" style={{color:"red"}}   onClick={()=>deleteEnquiries(record?.id)}/>
      </Space>
      )}
    />
  </Table>
        </div>
    )
}